export default "__VITE_ASSET__d48a5628__"